import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { ListerPagination } from '../../components/lister/ListerPagination';
import { makeGetTotalPages } from '../../redux/lister/selectors/ListerSelector';
export const ListerPaginationContainer = () => {
    const totalPages = useSelector(makeGetTotalPages());
    return _jsx(ListerPagination, { updateCanonicalLinkElement: false, totalPages: totalPages });
};
